// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"118":"d1cb8770","372":"a8e8fb6b"}[chunkId] + ".js";
};